import { useEffect, useState } from "react";
import { restaurant } from "../data/menu";

const links = [
  { href: "#menu", label: "Menu" },
  { href: "#galerie", label: "Galerie" },
  { href: "#localisation", label: "Localisation" },
  { href: "#horaires", label: "Horaires" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled
          ? "bg-[#fdfbf7]/85 backdrop-blur-xl border-b border-[#e5e0d5]"
          : "bg-[#fdfbf7]/85"
        }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src="/pizzas/logo.webp"
            alt="Piccola Venezia logo"
            className="h-14 w-auto object-contain logo-float"
          />
          <span className="leading-tight">
            <span className="block font-serif text-lg sm:text-xl text-[#1a1a1a]">
              {restaurant.name}
            </span>
            <span className="block text-[10px] sm:text-xs uppercase tracking-[0.18em] text-[#5c5c5c]">
              Mamers · 72600
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="pv-link text-sm uppercase tracking-[0.18em] text-[#1a1a1a] hover:text-[#c23b22] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={`tel:${restaurant.phoneRaw}`}
          data-testid="navbar-phone-cta"
          className="hidden md:inline-flex items-center gap-2 bg-[#c23b22] hover:bg-[#a12e1a] text-white px-5 py-2.5 rounded-full text-sm font-semibold shadow-sm transition-colors"
        >
          <i className="fa-solid fa-phone" aria-hidden="true"></i>
          <span>{restaurant.phone}</span>
        </a>

        <button
          data-testid="navbar-mobile-toggle"
          aria-label="Ouvrir le menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 inline-flex items-center justify-center rounded-full text-[#1a1a1a] hover:bg-black/5"
        >
          <i
            className={`fa-solid ${open ? "fa-xmark" : "fa-bars"} text-lg`}
            aria-hidden="true"
          ></i>
        </button>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-panel"
          className="md:hidden bg-[#fdfbf7] border-t border-[#e5e0d5] px-6 py-6 space-y-5"
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-${l.label.toLowerCase()}`}
              className="block text-base uppercase tracking-[0.18em] text-[#1a1a1a]"
            >
              {l.label}
            </a>
          ))}
          <a
            href={`tel:${restaurant.phoneRaw}`}
            data-testid="navbar-mobile-phone"
            className="inline-flex items-center gap-2 bg-[#c23b22] text-white px-5 py-3 rounded-full text-sm font-semibold"
          >
            <i className="fa-solid fa-phone" aria-hidden="true"></i>
            <span>{restaurant.phone}</span>
          </a>
        </div>
      )}
    </header>
  );
}
